import React, { ErrorInfo } from "react";
import { ErrorComponent } from "../components/ErrorComponent";
import * as Sentry from "@sentry/react-native";
import { Platform } from "react-native";
import { setNativeExceptionHandler } from "react-native-exception-handler";

interface ErrorBoundaryProps {
    children?: React.ReactNode;
}

interface ErrorBoundaryState {
    error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    public state: ErrorBoundaryState = {
        error: null,
    };

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI.
        return { error };
    }

    componentDidMount() {
        if (Platform.OS !== "web") {
            setNativeExceptionHandler((error: Error | string) => {
                Sentry.captureException(typeof error === "string" ? new Error(error) : error);
            });
        }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        Sentry.captureException(typeof error === "string" ? new Error(error) : error);
        console.warn("Uncaught error:", error, errorInfo);
    }

    clearError() {
        this.setState({ error: null });
    }
    render() {
        if (this.state.error) {
            const error = new Error(this.state.error.message || this.state.error.toString());
            return <ErrorComponent error={error} onClose={() => this.clearError()} />;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
